import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { UserManagementComponent } from '@gbr-monorepo/user-mgmt-ui';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { User } from '@gbr-monorepo/interfaces';
import { BackHomeComponent } from '../shared/components/back-home/back-home.component';
import { CreateUser, DeleteUser, GetUsers, UpdatePage, UpdateSearchTerm, UpdateUser } from './state/users.actions';
import { PageOptions, UsersState } from './state/users.state';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-user-management-wrapper',
    templateUrl: './user-management.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [UserManagementComponent, BackHomeComponent, TranslateModule]
})
export class UserManagementWrapperComponent implements OnInit {
    private readonly store = inject(Store);

    protected isLoading = this.store.selectSignal(UsersState.isLoading);
    protected users = this.store.selectSignal(UsersState.users);
    protected total = this.store.selectSignal(UsersState.total);
    protected pageOptions = this.store.selectSignal(UsersState.pageOptions);
    protected pageSizeOptions = [10, 25, 50, 100];
    protected readonly delegatesEnabled = !!environment.featureFlags?.delegatesEnabled;

    ngOnInit(): void {
        this.loadUsers();
    }

    private loadUsers(): void {
        this.store.dispatch(new GetUsers());
    }

    protected updateSearch(search: string): void {
        this.store.dispatch(new UpdateSearchTerm(search));
    }

    protected pageChange(pageOptions: PageOptions): void {
        const { page, pageSize } = pageOptions;
        this.store.dispatch(new UpdatePage({ pageSize, page: page - 1 }));
    }

    protected addUser(user: User): void {
        this.store.dispatch(new CreateUser(user as unknown as User));
    }

    protected editUser(user: User): void {
        this.store.dispatch(new UpdateUser(user as unknown as User));
    }

    protected deleteUser(gid: string): void {
        this.store.dispatch(new DeleteUser(gid));
    }
}
